<template>
	<div>
		<div class="app-container">
			<chat-container
				:current-user-id="userID"
				:theme="theme"
				v-if="showChat && userID"
			/>
		</div>
	</div>
</template>

<script>
import ChatContainer from './ChatContainer';
import mixin from '../../mixin.js';

export default {
	components: {
		ChatContainer
	},
	mixins: [mixin],

	data() {
		return {
			theme: 'light',
			showChat: true
		}
	},

	watch: {
		userID() {
			this.showChat = false;
			setTimeout(() => (this.showChat = true), 150);
		}
	}
}
</script>

<style lang="scss">
// Kill the .content wrapper's bottom padding so chat fills viewport
.content:has(.chat-page) {
	padding-bottom: 0 !important;
}

.app-container:has(.chat-page) {
	font-family: 'Quicksand', sans-serif;
	padding: 10px 20px 0 !important;
	display: flex !important;
	flex-direction: column !important;
	height: calc(100vh - 100px) !important;
	overflow: hidden !important;

	@media only screen and (max-width: 768px) {
		padding: 0 !important;
		height: 100vh !important;
	}
}
</style>